import { request } from './request';

export interface Notification {
  id: string;
  user_id: string;
  type: string;
  title: string;
  message: string;
  data?: any;
  read: boolean;
  read_at?: string;
  created_at: string;
}

export interface NotificationsResponse {
  success: boolean;
  data: Notification[];
  count: number;
  hasMore: boolean;
}

export interface UnreadCountResponse {
  success: boolean;
  count: number;
}

export const notificationsAPI = {
  // Get notifications with pagination
  getNotifications: async (page: number = 1, limit: number = 20, role?: string | null): Promise<NotificationsResponse> => {
    const params = new URLSearchParams({ page: page.toString(), limit: limit.toString() });
    if (role) params.append('role', role);
    return request<NotificationsResponse>(`/notifications?${params.toString()}`);
  },

  // Get unread count
  getUnreadCount: async (role?: string | null): Promise<number> => {
    const params = role ? `?role=${role}` : '';
    const response = await request<UnreadCountResponse>(`/notifications/unread-count${params}`);
    return response.count;
  },

  // Mark single notification as read
  markAsRead: async (notificationId: string): Promise<void> => {
    await request(`/notifications/${notificationId}/read`, {
      method: 'PATCH'
    });
  },

  // Mark multiple notifications as read
  markMultipleAsRead: async (notificationIds: string[]): Promise<void> => {
    await request('/notifications/mark-read', {
      method: 'POST',
      body: JSON.stringify({ notificationIds })
    });
  },

  // Mark all notifications as read
  markAllAsRead: async (): Promise<void> => {
    await request('/notifications/mark-all-read', {
      method: 'POST'
    });
  },

  // Delete notification
  deleteNotification: async (notificationId: string): Promise<void> => {
    await request(`/notifications/${notificationId}`, {
      method: 'DELETE'
    });
  }
};